import { render, staticRenderFns } from "./ObiLoading.vue?vue&type=template&id=9de21416&scoped=true&"
var script = {}
import style0 from "./ObiLoading.vue?vue&type=style&index=0&id=9de21416&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de21416",
  null
  
)

export default component.exports